/**
 * Denormalized label for asset.productVariants[] entries.
 * Mirrors db buildProductVariantLinkTitle.
 * @param {string} [productTitle]
 * @param {string} [variantTitle]
 * @returns {string}
 */
export default function buildProductVariantLinkTitle(productTitle = '', variantTitle = '') {
  const product = String(productTitle || '').trim();
  const variant = String(variantTitle || '').trim();

  if (product && variant) {
    return `${product} - ${variant}`;
  }

  return product || variant || '';
}
